import {
  COMPONENT_STATE_ARGS,
  MENU_ARGS,
  Metadata,
  pick,
} from '../../../../../utils/spds/metadata';
import { ROLE_MENU, ROLE_MENUITEM } from '../../../../../utils/spds/constants/aria';
import { hash } from '@ember/helper';
import Menu from '../../../core/menu/base.gjs';
import MenuItem from './menu-item.gjs';
import Super from '../../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Menu component for split buttons',
  extends: [
    pick(COMPONENT_STATE_ARGS, ['open', { name: 'animated', default: true }]),
    pick(MENU_ARGS, ['anchorElement', 'toggleOpenState']),
  ],
  name: 'Split Menu',
});

export default class SpdsActionButtonSplitMenu extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  get animated() {
    return this.argOrDefault('animated');
  }

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @animated={{this.animated}}
      @open={{@open}}
      data-test-spds-action-button-split-menu
      role={{ROLE_MENU}}
      {{this.validateArguments}}
      ...attributes
    >
      {{yield
        (hash
          Item=(component
            MenuItem showSelectedStyles=false role=ROLE_MENUITEM toggleOpenState=@toggleOpenState
          )
        )
      }}
    </Menu>
  </template>
}

export const ACTION_BUTTON_SPLIT_MENU_METADATA = SpdsActionButtonSplitMenu.metadata;
